import PropTypes from 'prop-types';
import React from 'react';

import IconButton from '~app/features/app/components/IconButton';

const MenuItem = ({ disabled, onClick, styleName, title, ariaLabel }) => (
  <div className="MenuItem" title={title}>
    <IconButton
      styleName={`MenuItem--${styleName}`}
      onClick={onClick}
      disabled={disabled}
      ariaLabel={ariaLabel}
    />
  </div>
);

MenuItem.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  styleName: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default MenuItem;
